import { useQuery } from "@apollo/client";
import { DistrictPicker, RegionPicker } from "containers";
import { FC, useMemo } from "react";
import { useSearch } from "react-location";
import { LocationGenerics } from "router/location";
import { useUrlState } from "utils";
import { GET_DISTRICTS } from "./apollo";
import { DistrictsMap } from "./map";

const DistrictsMapPage: FC = () => {
  const searchParams = useSearch<LocationGenerics>();
  const [region, setRegion] = useUrlState("region");
  const [district, setDistrict] = useUrlState("district");

  const filter = useMemo(
    () => ({
      page: 1,
      pageSize: 0,
      region: searchParams.region || undefined,
    }),
    [searchParams],
  );

  const { data, loading } = useQuery(GET_DISTRICTS, {
    variables: filter,
    notifyOnNetworkStatusChange: true,
  });

  return (
    <main className="flex-1 flex flex-row overflow-hidden bg-white divide-x divide-gray-200">
      <div className="flex flex-1 flex-col overflow-hidden divide-y divide-gray-200 min-h-0">
        <div className="h-20 px-6 flex-shrink-0 flex justify-between items-center">
          <div>
            <h3 className="text-lg font-medium text-gray-900">Districts Map</h3>
            <p className="text-sm text-gray-500">
              Displaying district boundaries and their respective regions to aid
              customer location identification.
            </p>
          </div>
          <div className="flex items-center gap-2">
            <RegionPicker
              id="region"
              labelHidden={true}
              setFieldTouched={() => {}}
              setFieldError={() => {}}
              setFieldValue={(_field: string, value: string) => {
                setRegion(value || "");
                setDistrict("");
              }}
              values={{ region }}
              rawId={true}
            />
            <DistrictPicker
              id="district"
              labelHidden={true}
              setFieldTouched={() => {}}
              setFieldError={() => {}}
              setFieldValue={(_field: string, value: string) => {
                setDistrict(value || "");
              }}
              values={{ district }}
              filter={{ region }}
              rawId={true}
            />
          </div>
        </div>
        <div className="flex flex-1 min-h-0 overflow-hidden">
          <DistrictsMap
            districts={data?.districts ?? []}
            loading={loading}
            selectedDistrictId={searchParams.district || undefined}
            regionId={searchParams.region || undefined}
            onDistrictSelect={setDistrict}
          />
        </div>
      </div>
    </main>
  );
};

export default DistrictsMapPage;
